var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.354 26.8367V20.6498C19.354 20.3764 19.2454 20.1141 19.052 19.9207C18.8587 19.7273 18.5964 19.6187 18.3229 19.6187H14.1983C13.9248 19.6187 13.6626 19.7273 13.4692 19.9207C13.2758 20.1141 13.1672 20.3764 13.1672 20.6498V26.8367C13.1672 27.1102 13.0585 27.3725 12.8651 27.5659C12.6718 27.7592 12.4095 27.8679 12.136 27.8679H5.94912C5.67564 27.8679 5.41336 27.7592 5.21999 27.5659C5.02661 27.3725 4.91797 27.1102 4.91797 26.8367V14.9141C4.92028 14.7714 4.95112 14.6306 5.00867 14.5C5.06622 14.3694 5.14933 14.2516 5.25309 14.1536L15.5646 4.78304C15.7547 4.60914 16.003 4.5127 16.2606 4.5127C16.5182 4.5127 16.7665 4.60914 16.9566 4.78304L27.2681 14.1536C27.3719 14.2516 27.455 14.3694 27.5125 14.5C27.5701 14.6306 27.6009 14.7714 27.6032 14.9141V26.8367C27.6032 27.1102 27.4946 27.3725 27.3012 27.5659C27.1078 27.7592 26.8456 27.8679 26.5721 27.8679H20.3852C20.1117 27.8679 19.8494 27.7592 19.6561 27.5659C19.4627 27.3725 19.354 27.1102 19.354 26.8367Z",
    className: "fill",
    strokeWidth: 2.0623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9376 4.19333L2.57856 16.5748C2.37225 16.7661 2.50755 17.1111 2.78884 17.1111H29.7241C30.0066 17.1111 30.1413 16.7635 29.9325 16.5732L16.3563 4.19165C16.2375 4.0833 16.0555 4.08403 15.9376 4.19333Z",
    className: "fill",
    strokeWidth: 2.0623,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/HOME.3a4af05ea8bdc3b8f77871faa5ce82b9.svg";
export { ForwardRef as ReactComponent };